import { Component, ElementRef, OnInit } from '@angular/core';
import { EnvService } from './core/services/env/env.service';
import { PlacesService } from './common/services/places/places.service';

declare var google: any;

@Component({
  selector: 'tcat-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'bizops-portal';

  constructor(
    private elementRef : ElementRef,
    private placesService: PlacesService,
    private envService: EnvService
  ) {
  }

  ngOnInit(): void {
    const mapApiKey = this.envService.getMapApiKey();
    console.log('loding maps api..');
    this.loadScript('https://maps.googleapis.com/maps/api/js?key=' + mapApiKey + '&libraries=places&v=3.57')
      .then(() => {
        //console.log('maps api loaded');              
      })
      .catch(err => {
        console.log('error: ', err);
      });

    const mapAttribution = this.elementRef.nativeElement.querySelector('#map-attribution');
    this.placesService.setDefaultMapAttribution(mapAttribution);
    setTimeout(() => { 
      //console.log('initied: ', google); 
      //console.log('with token: ', new google.maps.places.AutocompleteSessionToken());
    }, 3000); 
  }


  loadScript(name: string) {
    return new Promise<void>((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = name;
      document.getElementsByTagName('head')[0].appendChild(script);
      resolve();
    });
  }

}
